import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "Attachments";
var classes = {
    element: "".concat(PREFIX, "-element")
};
var AttachmentsStyled = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: "grid",
            width: "100%",
            gap: theme.spacing(1),
            padding: 0,
            margin: 0,
            listStyle: "none",
            gridAutoFlow: "row"
        },
        _b["& .".concat(classes.element)] = {},
        _b);
});

export { AttachmentsStyled, classes, AttachmentsStyled as default };
//# sourceMappingURL=index.styled.js.map
